import React from "react";
import { Link } from "react-router-dom";
import { Waves } from "lucide-react";

const COPY = {
  denied: "Was your claim denied after Hurricane Isaias? Our Northwest Florida pages cover the denial patterns we see on the Panhandle — causation, wind-versus-surge, and condo master-policy disputes:",
  underpaid: "Hurricane Isaias estimates on the Panhandle are frequently underscoped. Our Northwest Florida pages explain how we review a carrier's number for roof, water, surge, and condo losses:",
  roof: "Hurricane Isaias put thousands of Panhandle roofs into dispute over repairability and matching. See our Northwest Florida roof claim pages:",
  hurricane: "Hurricane Isaias made landfall near Destin on October 9, 2026 as a Category 2 hurricane. Property owners in the Panhandle can find storm-specific claim help on our Northwest Florida pages:",
};

const LINKS = {
  denied: [
    { to: "/pensacola-denied-insurance-claim", label: "Pensacola denied claim help" },
    { to: "/destin-denied-insurance-claim", label: "Destin denied claim help" },
  ],
  underpaid: [
    { to: "/pensacola-underpaid-insurance-claim", label: "Pensacola underpaid claim review" },
    { to: "/destin-underpaid-insurance-claim", label: "Destin underpaid claim review" },
  ],
  roof: [
    { to: "/pensacola-roof-damage-claims", label: "Pensacola roof damage claims" },
    { to: "/destin-roof-damage-claims", label: "Destin roof damage claims" },
  ],
  hurricane: [
    { to: "/hurricane-isaias-pensacola", label: "Hurricane Isaias Pensacola" },
    { to: "/hurricane-isaias-destin", label: "Hurricane Isaias Destin" },
  ],
};

// Contextual inbound link block from statewide authority pages into the NWFL hubs.
const NwflInboundLink = ({ topic = "hurricane" }) => {
  const links = LINKS[topic];
  return (
    <section className="py-10 bg-black border-t border-white/10" data-testid={`nwfl-inbound-${topic}`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="flex items-center gap-2 mb-3">
          <Waves className="h-4 w-4 text-[#E11D26]" />
          <span className="text-[#E11D26] text-xs font-bold tracking-[0.25em] uppercase">
            Northwest Florida · Hurricane Isaias
          </span>
        </div>
        <p className="text-white/75 text-sm sm:text-base leading-relaxed">
          {COPY[topic]}{" "}
          <Link to={links[0].to} className="text-[#E11D26] hover:text-white underline underline-offset-2 font-semibold">
            {links[0].label}
          </Link>
          {" and "}
          <Link to={links[1].to} className="text-[#E11D26] hover:text-white underline underline-offset-2 font-semibold">
            {links[1].label}
          </Link>
          .
        </p>
      </div>
    </section>
  );
};

export default NwflInboundLink;
